const state = new Proxy(
  {
    _projectId: undefined,
    image3D: undefined,
  },
  {
    set(target, prop, value) {
      target[prop] = value;

      if (value !== undefined && value !== null) {
        // Convert prop name for input field (remove leading underscore if present)
        // const inputProp = prop.startsWith("_") ? prop.substring(1) : prop;
        const inputSelector = `input[name="properties[${prop}]"]`;
        const input = document.querySelector(inputSelector);

        if (input) {
          input.value = value;
        }
      }

      return true;
    },
  }
);

var isMobile = window.innerWidth < 980;
var currentModelOrTemplate = null;
var lastVariant = null;

var createPacdora3d = () => {
  const imgs = document.querySelectorAll("media-carousel-slider img");
  const matchedElement = Array.from(imgs).find((el) =>
    el.src.match(/.*.pacdora.3d.*/)
  );
  console.log("matchedElement", matchedElement);
  if (matchedElement) {
    window.addEventListener(
      "click",
      (e) => {
        if (e.isTrusted === false) return;

        const path = (e.composedPath && e.composedPath()) || e.path;

        // Handle the open/close click
        const openBtn = path.find((item) => item.className === "pacdora-open");
        if (openBtn) {
          e.stopPropagation();
          openPacdora(0);
          return;
        }

        const closeBtn = path.find(
          (item) => item.className === "pacdora-close"
        );
        if (closeBtn) {
          e.stopPropagation();
          openPacdora(1);
          return;
        }

        const pacdoraContainer = path.find(
          (item) =>
            item.className?.includes("pacdora-container") ||
            item.className?.includes("pacdora-box")
        );
        if (pacdoraContainer) {
          e.stopPropagation();
        }
        const switchContainer = path.find((item) =>
          item.className?.includes("pacdora-switch-item")
        );
        if (switchContainer) {
          const switchItem = e.target;
          console.log(switchItem);
          let type = switchItem.dataset.type;
          // If the type cannot be found, look up the DOM to find data-type.
          if (!type) {
            let parentElement = switchItem.parentElement;
            while (parentElement && !type) {
              type = parentElement.dataset.type;
              // If an element of class 'pacdora-switch-item' is found, stop searching.
              if (
                parentElement.className &&
                parentElement.className.includes("pacdora-switch-item")
              ) {
                break;
              }
              parentElement = parentElement.parentElement;
            }
          }
          onSwitch2DAnd3D(type);
        }
      },
      true
    );
    window.addEventListener(
      "mousedown",
      (e) => {
        const path = (e.composedPath && e.composedPath()) || e.path;
        const pacdoraContainer = path?.find((item) =>
          item.className?.includes("pacdora-box-info")
        );
        if (pacdoraContainer) {
          e.stopPropagation();
        }
      },
      true
    );
    const div = document.createElement("div");
    Object.assign(div.style, { width: "100%", height: "100%" });
    div.className = "pacdora-box-info";
    const loadingDiv = document.createElement("div");
    loadingDiv.className = "pacdora-box-loading";
    div.appendChild(loadingDiv);
    const D3ContainerDiv = document.createElement("div");
    D3ContainerDiv.className = "pacdora-box-info-slider";
    const firstDiv = document.createElement("div");
    firstDiv.className = "pacdora-box-info-item";

    // Create the switch element
    const switchDiv = document.createElement("div");
    switchDiv.className = "pacdora-d3-and-d2-switch";
    switchDiv.innerHTML = `
        <div class="pacdora-switch-item active" data-type="3d">3D</div>
        <div class="pacdora-switch-item" data-type="dieline">Dieline</div>
      `;

    // Use addEventListener to bind events
    const switchItems = switchDiv.querySelectorAll(".pacdora-switch-item");
    switchItems.forEach((item) => {
      item.addEventListener("click", (e) => {
        const type = e.target.dataset.type;
        onSwitch2DAnd3D(type, e);
      });
    });

    // Create the control element
    const controlDiv = document.createElement("div");
    controlDiv.className = "pacdora-collapse-control";
    controlDiv.setAttribute("data-position", "bottom");
    controlDiv.style.display = "none";
    controlDiv.innerHTML = `
        <div class="pacdora-open">Open</div>
        <div class="pacdora-slider-box">
          <div class="pacdora-slider-line" onpointerdown="onSetSlider(event)"></div>
          <div class="pacdora-slider-selecter" onpointerdown="onSetSlider(event)"></div>
          <div class="pacdora-pointer" onpointerdown="onSliderDown(this)"></div>
        </div>
        <div class="pacdora-close">Close</div>
      `;
    // Replace the original image
    matchedElement.parentNode?.insertBefore(div, matchedElement);
    console.log("matchedElement.parentNode", matchedElement.parentNode);
    if(matchedElement.parentNode.tagName === "A"){
      matchedElement.parentNode.href = "javascript:void(0)";
      matchedElement.parentNode.removeAttribute("href");
      matchedElement.parentNode.style.cursor = "pointer";
      // 阻止父节点的默认事件
      matchedElement.parentNode.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
      }, true);
    }
    matchedElement.style.display = "none";
    // Create 3D container
    const d3Div = document.createElement("div");
    d3Div.className = "d3";
    d3Div.dataset.pacdoraUi = "3d";
    d3Div.dataset.pacdoraId = "d3";

    // Add the control to the 3D container
    firstDiv.appendChild(controlDiv);
    firstDiv.appendChild(d3Div);
    // Create the dieline container
    const dielineDiv = document.createElement("div");
    dielineDiv.className = "dieline";
    dielineDiv.dataset.pacdoraUi = "dieline";
    dielineDiv.dataset.notUseScience = true;
    const secondDiv = document.createElement("div");
    secondDiv.className = "pacdora-box-info-item";
    secondDiv.appendChild(dielineDiv);
    D3ContainerDiv.appendChild(firstDiv);
    D3ContainerDiv.appendChild(secondDiv);
    div.appendChild(D3ContainerDiv);
    div.appendChild(switchDiv);
    // Disable Swiper sliding function
    function disableSwiper() {
      // Method 1: Try to disable through instance
      const swiperContainer = document.querySelector('.swiper-container') || document.querySelector('.swiper');
      const swiperInstance = swiperContainer?.swiper;
      if (swiperInstance) {
        swiperInstance.allowTouchMove = false;
        console.log("Swiper disabled through instance");
        return;
      }
      
      // Method 2: Disable through CSS
      if (swiperContainer) {
        swiperContainer.style.pointerEvents = 'none';
        div.style.pointerEvents = 'auto'; // Keep 3D area interactive
        console.log("Swiper disabled through CSS");
      }
    }

    // Enable Swiper sliding function
    function enableSwiper() {
      const swiperContainer = document.querySelector('.swiper-container') || document.querySelector('.swiper');
      const swiperInstance = swiperContainer?.swiper;
      if (swiperInstance) {
        swiperInstance.allowTouchMove = true;
        console.log("Swiper enabled through instance");
        return;
      }
      
      if (swiperContainer) {
        swiperContainer.style.pointerEvents = '';
        console.log("Swiper enabled through CSS");
      }
    }

    // Add event listeners to 3D area
    div.addEventListener('pointerdown', disableSwiper);
    div.addEventListener('touchstart', disableSwiper);

    div.addEventListener('pointerup', enableSwiper);
    div.addEventListener('touchend', enableSwiper);
    div.addEventListener('pointercancel', enableSwiper);
    div.addEventListener('touchcancel', enableSwiper);
  }
};

// Get the currently selected variant
function getSelectedVariant() {
  let form_selector = window.PRODUCT_DATA.form_selector;
  if (!form_selector) {
    console.warn("No form_selector set");
    return null;
  }

  const form = document.querySelector(form_selector);
  if (!form) {
    console.warn("Form element not found:", form_selector);
    return null;
  }

  // Get all option selector values
  const selects = form.querySelectorAll("select");
  if (selects.length === 0) {
    console.warn("No selector elements found in form");
    return null;
  }

  const selectedOptions = [];
  console.log("selects", selects);
  selects.forEach((select) => {
    // Get the selected option element
    const selectedOption = select.options[select.selectedIndex];
    // Get the data-option-value-id attribute from the selected option
    selectedOptions.push(selectedOption.value);
  });

  console.log("Selected options:", selectedOptions);

  // Find variant matching all selected options
  const variant = window.PRODUCT_DATA.variants.find((v) => {
    const variantOptions = v.options.map((opt) => opt.name);
    console.log("Variant options:", variantOptions);
    return (
      selectedOptions.length === variantOptions.length &&
      selectedOptions.every((option, index) => option == variantOptions[index])
    );
  });

  console.log("Matching variant found:", variant);
  return variant;
}

// Listen for product option changes
function listenToFormSelectors() {
  const form_selector = window.PRODUCT_DATA.form_selector;
  if (!form_selector) {
    console.warn("No form_selector set");
    return;
  }

  console.log("Setting up document-level option change listener");

  document.addEventListener("change", function (e) {
    const path = (e.composedPath && e.composedPath()) || e.path;
    if (!path) {
      console.warn("Unable to get event path");
      return;
    }

    // Check if the event target is a selector
    if (e.target.tagName === "SELECT") {
      let isInTargetForm = false;
      for (let i = 0; i < path.length; i++) {
        const element = path[i];
        if (
          element.nodeType === 1 &&
          element.matches &&
          element.matches(form_selector)
        ) {
          isInTargetForm = true;
          break;
        }
      }

      if (isInTargetForm) {
        console.log("Selector in target form changed");
        const updatedVariant = getSelectedVariant();
        if (!updatedVariant) {
          console.warn("No matching variant found");
          return;
        }
        if (lastVariant?.metafields && updatedVariant?.metafields) {
          const lastKeys = Object.keys(lastVariant.metafields);
          const updatedKeys = Object.keys(updatedVariant.metafields);
          if (
            lastKeys.length === updatedKeys.length &&
            lastKeys.every(
              (key) =>
                updatedVariant.metafields.hasOwnProperty(key) &&
                lastVariant.metafields[key] === updatedVariant.metafields[key]
            )
          ) {
            return;
          }
        }
        console.log("Variant updated to:", updatedVariant.id);
        updatePacdoraWithVariant(updatedVariant);
      }
    }
  });

  console.log("Document-level option change listener added");
}

// Update Pacdora based on selected variant
async function updatePacdoraWithVariant(variant) {
  console.log("Updating Pacdora with new variant:", variant);

  // If Pacdora is initialized, update settings
  if (window.Pacdora) {
    try {
      lastVariant = variant;
      // Update material (if available)
      let useType = "";
      if (variant.metafields.modelId) {
        useType = "model";
      } else if (variant.metafields.templateId) {
        useType = "template";
      }
      if (
        useType &&
        currentModelOrTemplate !== variant.metafields.modelId &&
        currentModelOrTemplate !== variant.metafields.templateId
      ) {
        const loadingDiv = document.querySelector(".pacdora-box-loading");
        if (loadingDiv) {
          loadingDiv.style.display = "block";
        }
        await this.createPacdoraScene(useType, variant);
        if (loadingDiv) {
          loadingDiv.style.display = "none";
        }
        return;
      }
      let updateFlag = false;
      if (
        variant.metafields.material &&
        variant.metafields.material.trim() !== ""
      ) {
        await Pacdora.setMaterial({
          name: variant.name,
          image: variant.metafields.material,
          async: false,
        });
        updateFlag = true;
      }

      // Update size (if available)
      let size = variant.metafields.size;
      if (size) {
        // Handle 'x' and '*' cases
        const dimensions = size
          .toLowerCase()
          .replace(/[x*]/g, "*")
          .split("*")
          .map((str) => str.trim())
          .map(Number)
          .filter((num) => !isNaN(num));

        if (dimensions.length === 3) {
          const [length, width, height] = dimensions;
          console.log("Dimensions:", { length, width, height });
          await Pacdora.setSize({
            length,
            width,
            height,
            async: false,
          });
        }
        updateFlag = true;
      }

      // Apply updates
      if (updateFlag) {
        await Pacdora.update();
        console.log("Pacdora updated with new variant");
      }
    } catch (error) {
      console.error("Error updating Pacdora:", error);
    }
  } else if (window.PacdoraPlus) {
    // If using PacdoraPlus, do similar updates
    try {
      // Similar PacdoraPlus update logic
      console.log("PacdoraPlus update logic needs to be implemented");
    } catch (error) {
      console.error("Error updating PacdoraPlus:", error);
    }
  }
}
var createPacdora = async () => {
  const appId = window.PACDORA_CONFIG.appId;
  const version = window.PACDORA_CONFIG.basicVersion;
  if (!appId) {
    showMessage("No app id found");
    return;
  }
  const selectedVariant = window.PRODUCT_DATA.current_variant_id;
  const variantData = window.PRODUCT_DATA.variants.find(
    (v) => v.id == selectedVariant
  );
  lastVariant = variantData;
  const modelId = variantData.metafields.modelId
    ? variantData.metafields.modelId
    : window.PRODUCT_DATA.pacdora_model_id;
  const templateId = variantData.metafields.templateId
    ? variantData.metafields.templateId
    : window.PRODUCT_DATA.pacdora_template_id;
  if (!modelId && !templateId) {
    showMessage("No model or template id found");
    return;
  }
  let useType = "model";
  if (variantData.metafields.modelId) {
    useType = "model";
  } else if (variantData.metafields.templateId) {
    useType = "template";
  } else if (window.PRODUCT_DATA.pacdora_model_id) {
    useType = "model";
  } else if (window.PRODUCT_DATA.pacdora_template_id) {
    useType = "template";
  }
  console.log("Selected variant from form:", selectedVariant);
  console.log(modelId, appId);
  const imgs = document.querySelectorAll("img");
  const matchedElement = Array.from(imgs).find((el) =>
    el.src.match(/.*.pacdora.3d.*/)
  );
  if (matchedElement) {
    createPacdora3d();
  }
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.src = `https://cdn.pacdora.com/Pacdora-v${version}.js`;
  script.defer = true;
  script.onload = async () => {
    try {
      console.log("pacdora size:", variantData);

      await Pacdora.init({
        appId: appId,
        isDelay: true,
        theme: "#333333",
        doneBtn: "Save",
      });
      await createPacdoraScene(useType, variantData, modelId, templateId);

      Pacdora.$on("3d:init", () => {
        console.log("init-complete");
        const loadingDiv = document.querySelector(".pacdora-box-loading");
        if (loadingDiv) {
          loadingDiv.style.display = "none";
        }
      });
      const loadingBtnDiv = document.querySelectorAll(".pac-loading");
      if (loadingBtnDiv) {
        loadingBtnDiv.forEach((item) => {
          item.style.display = "none";
        });
      }
      if (Pacdora.project?.value?.cate?.complex_type === 0) {
        const controlDiv = document.querySelector(".pacdora-collapse-control");
        if (controlDiv) {
          controlDiv.style.display = "";
        }
      }
      Pacdora.$on("download:start", () => {
        const downloadEle = document.querySelector("#pacdora-download");
        downloadEle.style.cursor = "not-allowed";
        const downloadLoadingEle = downloadEle.querySelector(".pac-loading");
        const textEle = downloadEle.querySelector(".pac-text");
        if (textEle) {
          textEle.innerText = "Downloading...";
        }
        if (downloadLoadingEle) {
          downloadLoadingEle.style.display = "block";
        }
      });
      Pacdora.$on("download:success", () => {
        const downloadEle = document.querySelector("#pacdora-download");
        downloadEle.style.cursor = "pointer";
        const textEle = downloadEle.querySelector(".pac-text");
        if (textEle) {
          textEle.innerText = "Download success";
          setTimeout(() => {
            textEle.innerText = "Download Dieline";
          }, 1000);
        }
        const downloadLoadingEle = downloadEle.querySelector(".pac-loading");
        if (downloadLoadingEle) {
          downloadLoadingEle.style.display = "none";
        }
      });
      Pacdora.$on("download:fail", () => {
        const downloadEle = document.querySelector("#pacdora-download");
        if (downloadEle) {
          downloadEle.innerText = "Download failed";
          setTimeout(() => {
            downloadEle.innerText = "Download Dieline";
          }, 1000);
        }
        const downloadLoadingEle = downloadEle.querySelector(".pac-loading");
        if (downloadLoadingEle) {
          downloadLoadingEle.style.display = "none";
        }
      });
      const designButton = document.querySelector("#pacdora-design-btn");
      mobileBtnEventHijacking(designButton);
      if (designButton) {
        designButton.addEventListener("click", () => {
          const loadingEle = designButton.querySelector(".pac-loading");
          if (loadingEle) {
            loadingEle.style.display = "block";
          }
          const shopifyFixed = document.querySelector("#PBarNextFrameWrapper");
          if (shopifyFixed) {
            shopifyFixed.style.display = "none";
          }
        });
      }
      Pacdora.$on("design:opened", () => {
        const loadingEle = document.querySelector(
          "#pacdora-design-btn .pac-loading"
        );
        if (loadingEle) {
          loadingEle.style.display = "none";
        }
      });
       Pacdora.$on("design:save", async () => {
        const data = await Pacdora.getBoxInfo();
        state._projectId = data.id;
        state.image3D = data.screenshot;
      });
    } catch (err) {
      console.warn("Pacdora error:", err);
    }
  };
  document.body.appendChild(script);
};

function initPacdora() {
  window.PacdoraType = "basic";
  console.log("initPacdora");
  document.addEventListener("DOMContentLoaded", async () => {
    console.log("DOMContentLoaded");
    await createPacdora();
    // Add a listener for changes to the form selector
    listenToFormSelectors();
  });
}
var MAX_RETRIES = 3;
var loadPacdoraScript = (src) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.body.appendChild(script);
  });
};
var loadPacdoraScriptsWithRetry = async (urls, retries = 0) => {
  try {
    await Promise.all(urls.map(loadPacdoraScript));
    console.log("scripts loaded");
    return true;
  } catch (error) {
    console.error("script load failed:", error);
    if (retries < MAX_RETRIES) {
      console.log(`retry loading scripts... (${retries + 1}/${MAX_RETRIES})`);
      return loadPacdoraScriptsWithRetry(urls, retries + 1);
    } else {
      throw new Error("Failed to load scripts");
    }
  }
};
var createPacdoraPlus = async () => {
  console.log("createPacdoraPlus");
  window.PacdoraType = "plus";
  const basicVersion = window.PACDORA_CONFIG.basicVersion;
  const plusVersion = window.PACDORA_CONFIG.plusVersion;
  const selectedVariant = window.PRODUCT_DATA.current_variant_id;
  const variantData = window.PRODUCT_DATA.variants.find(
    (v) => v.id == selectedVariant
  );
  lastVariant = variantData;
  const modelId = variantData.metafields.modelId
    ? variantData.metafields.modelId
    : window.PRODUCT_DATA.pacdora_model_id;
  const templateId = variantData.metafields.templateId
    ? variantData.metafields.templateId
    : window.PRODUCT_DATA.pacdora_template_id;
  if (!modelId && !templateId) {
    showMessage("No model or template id found");
    return;
  }
  let useType = "model";
  if (variantData.metafields.modelId) {
    useType = "model";
  } else if (variantData.metafields.templateId) {
    useType = "template";
  } else if (window.PRODUCT_DATA.pacdora_model_id) {
    useType = "model";
  } else if (window.PRODUCT_DATA.pacdora_template_id) {
    useType = "template";
  }
  const appId = window.PACDORA_CONFIG.appId;
  if (!appId) {
    showMessage("No app id found");
    return;
  }
  createPacdora3d();
  const loadPacdoraScripts = async () => {
    return await loadPacdoraScriptsWithRetry([
      `https://cdn.pacdora.com/Pacdora-v${basicVersion}.js`,
      `https://cdn.pacdora.com/Pacdora-plus-v${plusVersion}.js`,
    ]);
  };

  let scriptsLoadedSuccessfully = await loadPacdoraScripts();
  if (!scriptsLoadedSuccessfully || typeof window.PacdoraPlus === "undefined") {
    console.error("PacdoraPlus is undefined, retrying script load...");
    await loadPacdoraScripts();
  }

  if (scriptsLoadedSuccessfully) {
    PacdoraPlus = window.PacdoraPlus;
    let Pacdora = window.Pacdora;
    if (typeof PacdoraPlus !== "undefined" && typeof Pacdora !== "undefined") {
      PacdoraPlus.use(Pacdora);
      console.log("Pacdora and PacdoraPlus initialized");
      PacdoraPlus.$on("quotation:form-complete", (data) => {
        console.log("quotation:form-complete", data);
        // Hide the skeleton screen and display the real content
      });
      await PacdoraPlus.init({
        appId: appId,
        isDelay: true,
        quotation: window.PACDORA_CONFIG.quotationOpen,
        customDefault: false,
        theme: "#333333",
      });
      await createPacdoraScene(useType, variantData, modelId, templateId);

      if (PacdoraPlus.project?.value?.cate?.complex_type === 0) {
        const controlDiv = document.querySelector(".pacdora-collapse-control");
        if (controlDiv) {
          controlDiv.style.display = "";
        }
      }
      PacdoraPlus.$on("3d:init", () => {
        console.log("init-complete");
        const loadingDivs = document.querySelectorAll(".pacdora-box-loading");
        loadingDivs.forEach((item) => {
          item.style.display = "none";
        });
        const skeletonSelects = document.querySelector(
          ".pacdora-skeleton-selects"
        );
        const selectorContent = document.querySelector(
          ".pacdora-selector-content"
        );
        if (skeletonSelects) {
          skeletonSelects.style.display = "none";
        }
        if (selectorContent) {
          selectorContent.style.display = "block";
        }
        const selectContent = document.querySelector(
          ".pacdora-selector-content"
        );
        if (selectContent) {
          selectContent.style.minHeight = "0px";
        }
        const selectorBox = document.querySelector(".pacdora-selector-box");
        if (selectorBox) {
          selectorBox.style.opacity = "1";
          selectorBox.style.height = "fit-content";
        }
        setTimeout(() => {
          const advancedData = PacdoraPlus.getAdvancedData();
          let size = advancedData.find(item=>item.type === "Size");
          console.log("size", size);
          if(size){
            setCustomizedThickness(size.selected);
          }
        }, 100);
      });
      const loadingBtnDiv = document.querySelectorAll(".pac-loading");
      if (loadingBtnDiv) {
        loadingBtnDiv.forEach((item) => {
          item.style.display = "none";
        });
      }
      const contactButton = document.querySelector("#pacdora-contact-button");
      if (contactButton) {
        contactButton.addEventListener("click", async () => {
          PacdoraPlus.openContactDialog({
            visible: true,
            canCancel: true,
            confirm: (result) => {
              console.log("confirm ===>", result);
            },
          });
        });
        contactButton.style.backgroundColor = "#000";
        contactButton.style.color = "#fff";
        contactButton.style.cursor = "pointer";
      }
      PacdoraPlus.$on("contact-dialog:loading", () => {
        const loadingEle = contactButton.querySelector(".pac-loading");
        if (loadingEle) {
          loadingEle.style.display = "block";
        }
      });
      PacdoraPlus.$on("contact-dialog:complete", () => {
        const loadingEle = contactButton.querySelector(".pac-loading");
        if (loadingEle) {
          loadingEle.style.display = "none";
        }
      });
      const buyButton = document.querySelector("#pacdora-buy-button");
      if (buyButton) {
        buyButton.addEventListener("click", async () => {
          await createShopifyOrder();
        });
        buyButton.style.backgroundColor = "#000";
        buyButton.style.color = "#fff";
        buyButton.style.cursor = "pointer";
      }
      const designButton = document.querySelector("#pacdora-advanced-design");
      mobileBtnEventHijacking(designButton);
      if (designButton) {
        designButton.addEventListener("click", () => {
          const loadingEle = designButton.querySelector(".pac-loading");
          if (loadingEle) {
            loadingEle.style.display = "block";
          }
        });
      }
      PacdoraPlus.$on("download:start", () => {
        const downloadEle = document.querySelector("#pacdora-download");
        downloadEle.style.cursor = "not-allowed";
        const downloadLoadingEle = downloadEle.querySelector(".pac-loading");
        const textEle = downloadEle.querySelector(".pac-text");
        if (textEle) {
          textEle.innerText = "Downloading...";
        }
        if (downloadLoadingEle) {
          downloadLoadingEle.style.display = "block";
        }
      });
      PacdoraPlus.$on("download:success", () => {
        const downloadEle = document.querySelector("#pacdora-download");
        downloadEle.style.cursor = "pointer";
        const textEle = downloadEle.querySelector(".pac-text");
        if (textEle) {
          textEle.innerText = "Download success";
          setTimeout(() => {
            textEle.innerText = "Download Dieline";
          }, 1000);
        }
        const downloadLoadingEle = downloadEle.querySelector(".pac-loading");
        if (downloadLoadingEle) {
          downloadLoadingEle.style.display = "none";
        }
      });
      PacdoraPlus.$on("download:fail", () => {
        const downloadEle = document.querySelector("#pacdora-download");
        if (downloadEle) {
          downloadEle.innerText = "Download failed";
          setTimeout(() => {
            downloadEle.innerText = "Download Dieline";
          }, 1000);
        }
        const downloadLoadingEle = downloadEle.querySelector(".pac-loading");
        if (downloadLoadingEle) {
          downloadLoadingEle.style.display = "none";
        }
      });
      PacdoraPlus.$on("design:opened", () => {
        const loadingEle = document.querySelector(
          "#pacdora-advanced-design .pac-loading"
        );
        if (loadingEle) {
          loadingEle.style.display = "none";
        }
        const shopifyFixed = document.querySelector("#PBarNextFrameWrapper");
        if (shopifyFixed) {
          shopifyFixed.style.display = "none";
        }
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
        document.body.style.top = `-${window.scrollY}px`;
      });
      PacdoraPlus.$on("advancedDesign:closed", () => {
        // Restore body scroll
        document.body.style.overflow = "";
        document.body.style.position = "";
      });
      PacdoraPlus.$on("advancedProject:change",(data)=>{
        let size = data.find(item=>item.type === "Size");
        if(size){
          setCustomizedThickness(size.selected);
        }
      })
    }
  }
};
async function setCustomizedThickness(size) {
  let sizeSplit = size.split("x").map(Number);
  let dimension = {
    length: sizeSplit[0],
    width: sizeSplit[1],
    height: sizeSplit[2],
  };
  const l = 227;
  const w = 157;
  const h = 75;
  const threshold = (3 * h + 2 * w) * (h * 4 + l);
  const area =
    (3 * dimension.height + 2 * dimension.width) *
    (dimension.height * 4 + dimension.length);
  if (area >= threshold) {
    if(Pacdora.project?.value.thickness !== 2.2){
      await Pacdora.setThickness({
        value: 2.2,
        async: true,
      });
    }
  } else {
    if(Pacdora.project?.value.thickness !== 1.6){
      await Pacdora.setThickness({
        value: 1.6,
        async: true,
      });
    }
  }
}
async function createShopifyOrder() {
  const buyLoading = document.querySelector("#pacdora-buy-button .pac-loading");
  if (buyLoading) {
    buyLoading.style.display = "block";
  }
  console.log("createShopifyOrder");
  await PacdoraPlus.waitProjectCreate();
  await PacdoraPlus.priceReady();
  let unitPrice = 0;
  let quantity = 1;
  const variantAttributes = [];
  const data = PacdoraPlus.getAdvancedData();
  const quantityData = PacdoraPlus.getQuantityData();
  if (data) {
    data.forEach((item) => {
      variantAttributes.push({
        key: item.type,
        value: item.selectedName,
      });
    });
  }
  if (quantityData) {
    unitPrice =
      quantityData.options.find(
        (item) => item.quantity === quantityData.quantity
      )?.unit_price ||
      quantityData.price / quantityData.quantity ||
      0;
    quantity = quantityData.quantity || 1;
  }
  const { screenshot, id } = await Pacdora.getBoxInfo();
  variantAttributes.push({
    key: "image3D",
    value: "https:" + screenshot,
  });
  variantAttributes.push({
    key: "projectId",
    value: id.toString(),
  });
  const postData = {
    variantId: window.PRODUCT_DATA.current_variant_id.toString(),
    unitPrice: unitPrice,
    quantity: quantity,
    variantAttributes: variantAttributes,
  };
  try {
    let response = await fetch(
      "https://api.pacdora.com/open/v1/shopify/order",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("api-token"),
        },
        body: JSON.stringify(postData),
      }
    );
    let res = await response.json();
    if (res.code === 200) {
      window.location.href = res.data.url;
    } else {
      showMessage("Create order failed");
    }
  } catch (err) {
    console.error("createShopifyOrder error:", err);
    showMessage("Create order failed");
  } finally {
    if (buyLoading) {
      buyLoading.style.display = "none";
    }
  }
}
async function initPacdoraPlus() {
  window.PacdoraType = "plus";
  document.addEventListener("DOMContentLoaded", async () => {
    setTimeout(async() => {
       await createPacdoraPlus();
       listenToFormSelectors();
    }, 100);
  
  });
}
function onSwitch2DAnd3D(type, event) {
  console.log("onSwitch", type);
  event?.stopPropagation();
  event?.preventDefault();
  const switchItems = document.querySelectorAll(".pacdora-switch-item");
  const boxInfo = document.querySelector(".pacdora-box-info-slider");
  if (type === "3d") {
    switchItems[0].className = "pacdora-switch-item active";
    switchItems[1].className = "pacdora-switch-item";
    boxInfo.style.transform = "translateX(0)";
  } else if (type === "dieline") {
    switchItems[0].className = "pacdora-switch-item";
    switchItems[1].className = "pacdora-switch-item active";
    boxInfo.style.transform = "translateX(-100%)";
  }
}
function openPacdora(ratio) {
  console.log("openpacdora", ratio);
  window.Pacdora.collapse("d3", ratio);
  const pointer = document.querySelector(".pacdora-pointer");
  pointer.style.left = `${ratio * 100}%`;
  const selected = document.querySelector(".pacdora-slider-selecter");
  selected.style.width = `${ratio * 100}%`;
}
function onSliderDown(e) {
  const parentBounding = e.parentNode.getBoundingClientRect();
  document.onpointermove = (ev) => {
    ev.stopPropagation();
    ev.preventDefault();
    const { clientX } = ev;
    const len = clientX - parentBounding.left;
    let ratio = len / parentBounding.width;
    if (ratio < 0) {
      ratio = 0;
    }
    if (ratio > 1) {
      ratio = 1;
    }
    window.Pacdora.collapse("d3", ratio);
    e.style.left = `${ratio * 100}%`;
    const selected = e.parentNode.querySelector(".pacdora-slider-selecter");
    selected.style.width = `${ratio * 100}%`;
  };
  document.onpointerup = (ev) => {
    ev.stopPropagation();
    ev.preventDefault();
    document.onpointermove = null;
    document.onpointerup = null;
  };
}

function onSetSlider(e) {
  e.stopPropagation();
  e.preventDefault();
  const parentBounding = e.target.parentNode.getBoundingClientRect();
  const len = e.clientX - parentBounding.left;
  let ratio = len / parentBounding.width;
  if (ratio < 0) {
    ratio = 0;
  }
  if (ratio > 1) {
    ratio = 1;
  }
  openPacdora(ratio);
}
function showMessage(message, type) {
  Pac_Shopify_Message.message({
    type: type,
    message,
  });
}
if (!window.pacdoraSectionLoadHandler) {
  window.pacdoraSectionLoadHandler = async (event) => {
    console.log("shopify:section:load", event, window.PacdoraType);
    if (window.PacdoraType === "basic") {
      await createPacdora();
    } else if (window.PacdoraType === "plus") {
      await createPacdoraPlus();
    }
  };
}

document.removeEventListener(
  "shopify:section:load",
  window.pacdoraSectionLoadHandler
);
document.addEventListener(
  "shopify:section:load",
  window.pacdoraSectionLoadHandler
);
async function createPacdoraScene(useType, variantData, modelId, templateId) {
  console.log("createPacdoraScene", useType, variantData, modelId, templateId);
  console.log(Pacdora.projectIsCreated);
  const dimension = {
    width: undefined,
    height: undefined,
    length: undefined,
  };
  const materialSetting = {
    materialName: undefined,
    materialImage: undefined,
  };
  if (variantData.metafields.material) {
    materialSetting.materialName = variantData.name;
    materialSetting.materialImage = variantData.metafields.material;
  }
  let size = variantData.metafields.size;
  if (size) {
    const dimensions = size
      .toLowerCase() // Convert to lowercase
      .replace(/[x*]/g, "*") // Replace all x and * with *
      .split("*")
      .map((str) => str.trim())
      .map(Number)
      .filter((num) => !isNaN(num));

    if (dimensions.length === 3) {
      const [length, width, height] = dimensions;
      console.log("Size dimensions:", { length, width, height });
      dimension.length = length;
      dimension.width = width;
      dimension.height = height;
    }
  }
  if (!useType || !variantData) {
    console.warn("Missing parameters for creating scene");
    return null;
  }

  let sceneParams = {
    doneBtn: "Save",
    isCreatePreview: false,
    advancedSetting: {
      ...materialSetting,
      width: dimension.width,
      height: dimension.height,
      length: dimension.length,
    },
    packagingColors: ["#ff0000", "#00ff00", "#0000ff", "#893829"],
  };

  if (useType === "model" && variantData.metafields.modelId) {
    sceneParams.modelId = variantData.metafields.modelId;
  } else if (useType === "template" && variantData.metafields.templateId) {
    sceneParams.templateId = variantData.metafields.templateId;
  } else if (useType === "model" && modelId) {
    sceneParams.modelId = modelId;
  } else if (useType === "template" && templateId) {
    sceneParams.templateId = templateId;
  } else {
    console.warn("Invalid useType or missing ID");
    return null;
  }
  try {
    currentModelOrTemplate = sceneParams.modelId || sceneParams.templateId;
    if (window.PacdoraType === "plus") {
      const id = await PacdoraPlus.createScene(sceneParams);
      const info = await Pacdora.getBoxInfo();
      state._projectId = info.id;
      state.image3D = info.screenshot;
      return id;
    } else {
      const id = await Pacdora.createScene(sceneParams);
      state._projectId = info.id;
      state.image3D = info.screenshot;
      return id;
    }
  } catch (err) {
    console.error("Error creating scene:", err);
    const loadingDiv = document.querySelector(".pacdora-box-loading");
    if (loadingDiv) {
      loadingDiv.style.display = "none";
    }
    return null;
  }
}
function mobileBtnEventHijacking(dom) {
  if (isMobile) {
    dom.addEventListener(
      "click",
      (e) => {
        showMessage("Please Use Desktop for the Best Experience.", "warn");
        e.stopPropagation();
        e.preventDefault();
      },
      {
        capture: true,
      }
    );
  }
}
class Pac_Shopify_Message {
  static message({ type, message }) {
    let messageBox = document.querySelector(".message-box");
    if (!messageBox) {
      messageBox = document.createElement("div");
      messageBox.className = "message-box";
      Object.assign(messageBox.style, {
        position: "fixed",
        top: "32px",
        left: 0,
        right: 0,
        margin: "auto",
        zIndex: 1999000000,
        textAlign: "center",
      });
      document.body.appendChild(messageBox);
    }
    const div = document.createElement("div");
    div.style.marginBottom = "24px";
    const messageItem = document.createElement("div");
    div.appendChild(messageItem);
    Object.assign(messageItem.style, {
      height: "48px",
      background: "#ffffff",
      borderRadius: "24px",
      boxShadow: "0px 2px 10px 0px rgba(0,0,0,0.12)",
      display: "inline-block",
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "48px",
      padding: "0 20px",
      animation: "message-in 0.5s",
    });
    let img = ``;
    if (type === "success") {
      img = `<img style="margin-right: 8px;width:24px;height:24px;vertical-align: middle;" src="https://cloud.pacdora.com/ui/success.png"/>`;
    } else if (type === "warn") {
      img = `<img style="margin-right: 8px;width:24px;height:24px;vertical-align: middle;" src="https://cloud.pacdora.com/ui/warn.png"/>`;
    } else if (type === "error") {
      img = `<img style="margin-right: 8px;width:24px;height:24px;vertical-align: middle;" src="https://cloud.pacdora.com/ui/error.png"/>`;
    }
    messageItem.innerHTML = `
        ${img}
        ${message}
    `;
    messageBox.appendChild(div);
    setTimeout(() => {
      messageBox?.removeChild(div);
    }, 2000);
  }
  static success(message) {
    this.message({ type: "success", message });
  }
  static warn(message) {
    this.message({ type: "warn", message });
  }
  static error(message) {
    this.message({ type: "error", message });
  }
}
